import React, { useState } from 'react';
import Box from '@mui/material/Box';
import AmazonUploadForm from './AmazonUploadForm';
import AmazonUploadTable from './AmazonUploadTable';
import AmazonBulkUpload from './AmazonBulkUpload';
import orderHelpers from '../../helpers/orders';

function AmazonUploadPage(props) {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [orders, setOrders] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const handleDateChange = (value, field) => {
    if (field === 'startDate') setStartDate(value);
    if (field === 'endDate') setEndDate(value);
  };

  const getAmazonUploads = async () => {
    try {
      setLoading(true);
      const response = await orderHelpers.getAmazonUploads(props.company, {startDate}, props.token);
      setOrders(response.message || []);
    } catch (err) {
      console.log('getAmazonUploads error', err);
    } finally {
      setLoading(false);
    }
  };

  return (
      <Box display="flex" flexDirection="column"
        sx={{
          ml: props.isMobile ? 0 : "100px",
          px: 3,
          py: 2
        }}
      >
    <Box display="flex" justifyContent="flex-start" mb={3}>
        <AmazonBulkUpload
          isMobile={props.isMobile}
          company={props.company}
          warehouse={props.warehouse}
          user={props.user}
          token={props.token}
          scopes={props.scopes}
          setLoading={setLoading}
          isLoading={isLoading}
        />
      </Box>
      <Box display="flex" flexDirection="column" gap={3}>
      <AmazonUploadForm
        isMobile={props.isMobile}
        customer={props.customer}
        startDate={startDate}
        endDate={endDate}
        isLoading={isLoading}
        handleDateChange={handleDateChange}
        getAmazonUploads={getAmazonUploads}
      />

      <AmazonUploadTable
        isMobile={props.isMobile}
        orders={orders}
      />
     </Box> 
    </Box>
  );
}

export default AmazonUploadPage;